import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNoAuth } from "./axiosInstance";

export const checkUserInWhiteList = createAsyncThunk(
  "checkUserInWhiteList",
  async ({ email }) => {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:auth-service/authorize-collab/ffe_whitelist",
        { email }
      );
      return response.data;
    } catch (error) {
      console.log(error.message);
    }
  }
);

const whiteListSlice = createSlice({
  name: "whiteList",
  initialState: {
    checkWhiteListUser: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(checkUserInWhiteList.fulfilled, (state, action) => {
      state.checkWhiteListUser = action.payload;
    });
  },
});

export const selectWhiteListStatus = (state) =>
  state.personaliseLessons?.whiteList?.checkWhiteListUser;
export default whiteListSlice.reducer;
